<email-layout>
  <ng-container logo>
    <email-referrals-logo [lang]="data().language" />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data().title" [subheader]="data().p1" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data().slogan | mailgunMarkAsHtml" />
    <email-margin [height]="36" />
    <email-button [href]="data().button_link" [label]="data().button_text" theme="primary" />
    <email-margin [height]="18" />
    <email-text [contents]="data().p2_html" color="light" className="web-rt-contains-link" />
    <email-margin [height]="36" />
    <email-text [contents]="data().p3" size="small" color="light" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
